<template>
  <div id="teams-btn" class="full-width">
    <button
      :disabled="disabled"
      @click="showMemberForm = true"
      class="tw-text-white tw-my-6 tw-text-sm tw-flex tw-items-center tw-bg-primary tw-gap-2 tw-rounded tw-px-6 tw-w-max tw-h-12"
    >
      <svg
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.01364 6.97876V0.97876H9.18873V6.97876H15.714V8.97876H9.18873V14.9788H7.01364V8.97876H0.488342V6.97876H7.01364Z"
          fill="white"
        />
      </svg>
      {{ title }}
    </button>
    <Teleport to="#teleport-modal">
      <AddTeamMember
        v-if="showMemberForm"
        source="company"
        @close-modal="showMemberForm = false"
        @success="toggleSuccessModal"
      />
      <SuccessModal
        v-if="showSuccessModal"
        @close="closeSuccessModal"
        :show="showSuccessModal"
        v-bind="{
          title: 'Success',
          body: 'You have added this user to your team.They have been notified via the provided email.',
        }"
      />
    </Teleport>
  </div>
</template>
    
    <script setup>
import AddTeamMember from "./AddTeamMember.vue";
import SuccessModal from "@/components/general/SuccessModal.vue";
import { useStore } from "vuex";
import { onBeforeUnmount, ref } from "vue";

const store = useStore();

const emit = defineEmits(["member-added"]);

const props = defineProps({
  title: {
    type: String,
    default: () => "",
    required: true,
  },
  buttonType: {
    type: String,
    required: false,
    default: () => "",
  },
  disabled: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  addteam: {
    type: Boolean,
    required: false,
    default: () => false,
  },
});

const triggeredBy = ref(0);
const btnLoading = ref(false);
const showMemberForm = ref(false);
const showSuccessModal = ref(false);

const toggleSuccessModal = () => {
  showSuccessModal.value = true;
  showMemberForm.value = false;

  emit("member-added");
};

const closeSuccessModal = async () => {
  showSuccessModal.value = false;
};
</script>
    
  <style scoped>
.full-width {
  width: 100%;
}

.padding {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
</style>